import { Component, OnInit } from '@angular/core';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DeviceInLetter',
  templateUrl: './DeviceInLetter.component.html',
  styleUrls: ['./DeviceInLetter.component.scss']
})
export class DeviceInLetterComponent implements OnInit {

  Token: String = ""
  page: number = 0;
  Procssing: boolean = false


  Name: string = ''
  Code: string = ''

  constructor(
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private Device_Service: DeviceService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2178).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  DataList_DeviceInLetter:Array<any>=[]
  ReadData_DeviceInLetter(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.Device_Service.GetDeviceInLetter(
      this.Token,
      StartSearchDate,
      EndSearchDate,
      this.Name,
      this.Code).subscribe(
        data => {
          this.DataList_DeviceInLetter = data
          this.Procssing = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

  
}
